import { API_URL } from '../../../api';
import { axios } from '../../../plugins/axios';
import { stripFrameLocations } from './strip-frame-locations';
const MAX_FIELD_LENGTH = 8000;
const truncate = (value) => (value !== null && value !== void 0 ? value : '').slice(0, MAX_FIELD_LENGTH);
export const reportCrash = ({ app, error, componentStack, }) => {
    try {
        const payload = {
            app,
            message: truncate(error === null || error === void 0 ? void 0 : error.message),
            stack: truncate(stripFrameLocations(error === null || error === void 0 ? void 0 : error.stack)),
            componentStack: truncate(stripFrameLocations(componentStack)),
            url: typeof window !== 'undefined'
                ? `${window.location.origin}${window.location.pathname}`
                : '',
            userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
            timestamp: Date.now(),
        };
        void axios
            .post(`${API_URL}/telemetry/crash-report`, payload, { timeout: 5000 })
            .catch(() => undefined);
    }
    catch (_a) {
    }
};
